require('./insuranceRequestProductMobileDetail.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ constants
const { MOBILE_INSURANCE_PLANS_PERCENTAGE } = require('../../../insuranceConstants/insuranceRequestMobile');

class InsuranceRequestProductMobileDetail extends React.Component {
    constructor(props) {
        super(props);
    }

    buildDisclaimerMobile() {
        const { isDisclaimerMobileEnabled } = this.props;
        return isDisclaimerMobileEnabled ? (
            <OKMessage>
                <FormattedText value="insuranceConsultiveProductDetails-insuranceConsultiveProductDetails_disclaimer" />
            </OKMessage>) : null;
    }

    render() {
        const { immPolicyDetails, immPolicyComplementaryInformation } = this.props;

        const takerInfo = immPolicyDetails.getIn(['taker', 'name']);
        const insurancePlan = immPolicyComplementaryInformation.get('insurancePlan');
        const insurancePercentage = MOBILE_INSURANCE_PLANS_PERCENTAGE[insurancePlan];
        const insurancePlanText = insurancePercentage ? formatText('insuranceConsultiveProductDetails-mobilePlanText', [insurancePercentage]) : '';
        const mobileImeiTooltip = <FormattedText value="insuranceConsultiveProductDetails-insuranceConsultiveProductDetails_mobileImeiTooltip" />;
        const imeiPendingText = formatText('insuranceConsultiveProductDetails-insuranceConsultiveProductDetails_mobileImeiPending');
        const imeiPendingMessage = <FormattedText value="insuranceConsultiveProductDetails-insuranceConsultiveProductDetails_mobileImeiPendingMessage" />;
        const imeiPendingMessageTitle = formatText('insuranceConsultiveProductDetails-insuranceConsultiveProductDetails_mobileImeiPendingMessageTitle');
        const deviceImei = immPolicyComplementaryInformation.get('deviceImei');
        const imeiBodyText = deviceImei || imeiPendingText;
        const okSectionImeiClass = !deviceImei && 'insurance-request-product-detail-description-ok-section-bottom__imei';
        const disclaimerMobile = this.buildDisclaimerMobile();
        const showImeiPendingMessage = !deviceImei && (
            <div className="row">
                <div className="col-xs-12 insurance-request-product-detail-description-ok-section-bottom__field-errors-message">
                    <OKMessage
                        title={imeiPendingMessageTitle}
                        type="warning">
                        {imeiPendingMessage}
                    </OKMessage>
                </div>
            </div>
        )
        return (
            <OKSectionBox
                className="insurance-request-product-detail-description-ok-section-bottom">
                <article>
                    <OKBoxTitle
                        value={formatText('insuranceConsultiveProductDetails-insuranceDetailsTitle')}
                        inline={true}
                    >
                    </OKBoxTitle>
                    <section className="insurance-request-product-detail-description-ok-section-bottom__body">
                        {showImeiPendingMessage}
                        <OKInformativeList
                            title={formatText('insuranceConsultiveProductDetails-insuredValues')}
                            columns={2}
                        >
                            <OKInformativeListItem
                                title={formatText('insuranceConsultiveProductDetails-insuranceType')}
                                bodyText={formatText('insuranceConsultiveProductDetails-mobileInsuranceType')}
                            />
                            <OKInformativeListItem
                                title={formatText('insuranceConsultiveProductDetails-mobilePlan')}
                                bodyText={insurancePlanText}
                            />
                            <OKInformativeListItem
                                title={formatText('insuranceConsultiveProductDetails-mobileBrand')}
                                bodyText={immPolicyComplementaryInformation.get('deviceBrand')}
                            />
                            <OKInformativeListItem
                                title={formatText('insuranceConsultiveProductDetails-mobileModel')}
                                bodyText={immPolicyComplementaryInformation.get('deviceModel')}
                            />
                            <OKInformativeListItem
                                title={formatText('insuranceConsultiveProductDetails-mobileAlias')}
                                bodyText={immPolicyComplementaryInformation.get('insuranceAlias')}
                            />
                            <OKInformativeListItem
                                className={okSectionImeiClass}
                                title={formatText('insuranceConsultiveProductDetails-mobileImei')}
                                bodyText={imeiBodyText}
                                icon={true}
                                information={mobileImeiTooltip}
                                tooltipPlacement={'top'}
                                tooltipOffset={[0, -15]}
                                tooltipSize={'large'}
                            />
                        </OKInformativeList>
                        <OKInformativeList
                            title={formatText('insuranceConsultiveProductDetails-interveners')}
                            columns={1}
                        >
                            <OKInformativeListItem
                                title={formatText('insuranceConsultiveProductDetails-taker')}
                                bodyText={takerInfo}
                            />
                        </OKInformativeList>
                        {disclaimerMobile}
                    </section>
                </article>
            </OKSectionBox>
        );
    }
}

InsuranceRequestProductMobileDetail.propTypes = {
    immPolicyDetails: PropTypes.object.isRequired,
    immPolicyComplementaryInformation: PropTypes.object.isRequired,
    isDisclaimerMobileEnabled: PropTypes.bool.isRequired,
}

module.exports = InsuranceRequestProductMobileDetail;
